<template>
    <div class="overhaul-register-con">
        <div class="overhaul-search-con">
            <el-form :inline="true" ref="searchForm" class="leader-style-form">
                <el-form-item label="单号">
                    <el-input v-model="searchForm.check_repair_no" maxlength="50"></el-input>
                </el-form-item>
                <el-form-item label="计划检修时间">
                    <el-date-picker
                        v-model="searchForm.plan_time_start"
                        type="date"
                        placeholder="选择日期"
                        :default-value="timeNow"
                        value-format="yyyy-MM-dd"
                        format="yyyy-MM-dd"
                        :picker-options="pickerOptions"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item label="检修状态">
                    <el-select v-model="searchForm.check_repair_state">
                        <el-option
                            v-for="item in checkRepairStates"
                            :key="item.code_value"
                            :label="item.code_name"
                            :value="item.code_value"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button @click="getCheckList()" type="warning">查询</el-button>
                    <el-button @click="addOverhaulDialog" type="primary">新增</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="table-wrap">
            <el-table :data="tableData" border class="leader-style-table">
                <el-table-column width="50" align="center" label="序号">
                    <template slot-scope="scope">
                        <span>
                            {{
                                (pageNum - 1) * pageSize + scope.$index + 1
                            }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="单号" property="check_repair_no" align="center"></el-table-column>
                <!-- <el-table-column
                    label="常规检修设备数量"
                    property="b"
                ></el-table-column>
                <el-table-column
                    label="待检修项目数量"
                    property="c"
                ></el-table-column>-->
                <el-table-column label="计划检修开始时间" property="plan_time_start" align="center"></el-table-column>
                <el-table-column label="是否停电" property="is_power_cut" align="center"></el-table-column>
                <el-table-column label="工作负责人" property="leader_name" align="center"></el-table-column>
                <el-table-column label="计划状态" property="check_repair_state_name" align="center"></el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button
                            @click="changeOverhaulShow(scope.row)"
                            type="text"
                            class="button-modify"
                            v-if="scope.row.check_repair_state == '20'"
                        >
                            <i class="iconfont iconeditor"></i>
                            <span class="inner-text">修改</span>
                        </el-button>
                        <el-button
                            @click="deleteItemShow(scope.row)"
                            type="text"
                            class="button-delete"
                            v-if="scope.row.check_repair_state == '20'"
                        >
                            <i class="iconfont iconashbin"></i>
                            <span class="inner-text">删除</span>
                        </el-button>
                        <el-button
                            @click="arrangeOverhaulShow(scope.row)"
                            type="text"
                            class="button-custom"
                        >
                            <i class="iconfont iconsearch"></i>
                            <span class="inner-text">查看</span>
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                class="leader-style-pagination"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 30, 40, 50, 100]"
                :page-size="pageSize"
                style="margin-top: 20px"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalNum"
            ></el-pagination>
        </div>
        <el-dialog
            class="leader-dialog"
            :title="dialogTitle"
            width="1000px"
            :visible.sync="overRegisterVisible"
            @close="closeDialog"
            :close-on-click-modal="false"
            :destroy-on-close="true"
        >
            <el-scrollbar style="height: 470px;">
                <div style="display: flex;height: 100%">
                    <div style="height: 470px; width: 280px" v-show="!isLookLook">
                        <el-scrollbar style="height: 100%">
                            <div class="tree-wrap">
                                <me-tree
                                    ref="myTree"
                                    :treeData="treeData"
                                    :treeLoading="treeLoading"
                                    :treeToolBar="false"
                                    :defaultProps="defaultProps"
                                    :nodeKey="'tree_id'"
                                    :showCheckbox="true"
                                    :title="''"
                                    :cascadingVar="true"
                                    :defaultExpandedKeys="defaultCheckKeys"
                                    :checkStrictly="true"
                                    :isCheckClick="true"
                                    :defaultCheckKeys="defaultCheckKeys"
                                    @handleCheckBoxClick="handleTreeNodeClick"
                                ></me-tree>
                            </div>
                        </el-scrollbar>
                    </div>
                    <div>
                        <div class="overhaul-tab-wrap">
                            <el-tag
                                v-for="tag in addForm.deviceTags"
                                :key="tag"
                                :closable="canClose"
                                @close="handleRemoveTime(tag)"
                                :disable-transitions="true"
                            >{{ tag }}</el-tag>
                        </div>
                        <el-form
                            class="leader-style-form"
                            :rules="formRules"
                            :model="addForm"
                            ref="addForm"
                        >
                            <el-row :gutter="20">
                                <el-col :span="11">
                                    <el-form-item
                                        label="计划开始时间"
                                        :label-width="labelWidth"
                                        prop="plan_time_start"
                                    >
                                        <el-date-picker
                                            v-model="addForm.plan_time_start"
                                            type="date"
                                            placeholder="选择日期"
                                            :default-value="timeNow"
                                            value-format="yyyy-MM-dd"
                                            format="yyyy-MM-dd"
                                            style="width: 100%"
                                            :picker-options="pickerOptions"
                                            :disabled="isLookLook"
                                        ></el-date-picker>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="11">
                                    <el-form-item
                                        label="计划结束时间"
                                        :label-width="labelWidth"
                                        prop="plan_time_end"
                                    >
                                        <el-date-picker
                                            v-model="addForm.plan_time_end"
                                            type="date"
                                            :disabled="isLookLook"
                                            placeholder="选择日期"
                                            :default-value="timeNow"
                                            value-format="yyyy-MM-dd"
                                            format="yyyy-MM-dd"
                                            style="width: 100%"
                                            :picker-options="pickerOptions"
                                        ></el-date-picker>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="11">
                                    <el-form-item
                                        label="工作负责人"
                                        :label-width="labelWidth"
                                        prop="leader_id"
                                    >
                                        <el-select
                                            style="width: 100%"
                                            v-model="addForm.leader_id"
                                            @change="changeLeader"
                                            :disabled="isLookLook"
                                        >
                                            <el-option
                                                v-for="item in leaders"
                                                :key="item.leader_user_id"
                                                :label="item.leader_name"
                                                :value="item.leader_user_id"
                                            ></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="11">
                                    <el-form-item
                                        label="内部检修人员"
                                        :label-width="labelWidth"
                                        prop="worker_ids"
                                    >
                                        <el-select
                                            style="width: 100%"
                                            multiple
                                            v-model="addForm.worker_ids"
                                            :disabled="isLookLook"
                                        >
                                            <el-option
                                                v-for="item in workers"
                                                :key="item.user_id"
                                                :label="item.user_name"
                                                :value="item.user_id"
                                            ></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="11">
                                    <el-form-item
                                        label="外部检修人员"
                                        :label-width="labelWidth"
                                        prop="out_worker_name"
                                    >
                                        <el-input
                                            v-model="addForm.out_worker_name"
                                            maxlength="30"
                                            :disabled="isLookLook"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="11">
                                    <el-form-item
                                        label="是否停电"
                                        :label-width="labelWidth"
                                        prop="is_power_cut"
                                    >
                                        <el-radio-group
                                            class="leader-style-radio"
                                            v-model="addForm.is_power_cut"
                                            :disabled="isLookLook"
                                        >
                                            <el-radio label="1">是</el-radio>
                                            <el-radio label="0">否</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="22">
                                    <el-form-item
                                        label="备注"
                                        style="width: 100%;"
                                        :label-width="labelWidth"
                                    >
                                        <el-input
                                            v-model="addForm.remark"
                                            type="textarea"
                                            :disabled="isLookLook"
                                            rows="4"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </div>
                </div>
            </el-scrollbar>
            <div slot="footer" class="dialog-footer" v-if="!isLookLook">
                <el-button @click="overRegisterVisible = false" class="leader-common-button">取消</el-button>
                <el-button
                    type="primary"
                    @click="changeCommit('addForm')"
                    class="leader-common-button"
                >保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import Tree from '@/comon/components/tree.vue';
import * as api from '../api/index';
export default {
    components: {
        'me-tree': Tree,
    },
    data() {
        return {
            labelWidth: '120px',
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
            },
            checkRepairStates: [],
            searchForm: {
                check_repair_no: '', //检修单号
                plan_time_start: '', //计划检修时间
                check_repair_state: '', //检修状态
            },
            tableData: [],
            pageNum: 1, //页码
            pageSize: 10, //每页条数
            currentPage: 1, //当前页码
            totalNum: 0, //总条数
            dialogTitle: '新增检修',
            isLookLook: false,
            overRegisterVisible: false,
            treeLoading: false,
            treeData: [],
            defaultProps: {
                children: 'childList',
                label: 'tree_name',
            },
            defaultExpandedKeys: [],
            defaultCheckKeys: [],
            addForm: {
                deviceTags: [], //设备tag
                deviceIds: [],
                plan_time_start: '', //计划开始时间
                plan_time_end: '', //计划结束时间
                leader_id: '', //负责人
                worker_ids: '', //内部检修人员
                out_worker_name: '', //外部检修人员
                is_power_cut: '0', //是否停电 0否 1是
                remark: '', //备注
                tree_id_list: [],
                check_repair_id: '',
            },
            leaders: [],
            workers: [],
            formRules: {
                plan_time_start: [
                    {
                        required: true,
                        message: '请选择计划开始时间',
                        trigger: 'changge',
                    },
                ],
                plan_time_end: [
                    {
                        required: true,
                        message: '请选择计划结束时间',
                        trigger: 'changge',
                    },
                ],
                leader_id: [
                    {
                        required: true,
                        message: '请选择负责人',
                        trigger: 'changge',
                    },
                ],
                worker_ids: [
                    {
                        required: true,
                        message: '请选择内部检修人员',
                        trigger: 'changge',
                    },
                ],
                is_power_cut: [
                    {
                        required: true,
                        message: '请选择是否停电',
                        trigger: 'changge',
                    },
                ],
            },
        };
    },
    mounted() {
        this.getUnitDocTreeList();
        this.getCheckRepairState();
        this.getCheckList();
        this.getLeader();
    },
    methods: {
        //获取检修状态
        getCheckRepairState() {
            api.getCodelistByKind({
                code_kind: 'check_repair_state',
            }).then((res) => {
                if (res) {
                    this.checkRepairStates = res.bus_json[0].codelists;
                }
            });
        },
        //获取检修列表
        getCheckList() {
            api.getCheckList({
                pageNum: this.pageNum,
                pageSize: this.pageSize,
                check_repair_no: this.searchForm.check_repair_no,
                plan_time_start: this.searchForm.plan_time_start,
                check_repair_state: this.searchForm.check_repair_state,
            }).then((res) => {
                if (res) {
                    this.tableData = res.bus_json.items;
                    this.pageNum = res.bus_json.pageNum;
                    this.pageSize = res.bus_json.pageSize;
                    this.totalNum = res.bus_json.totalNum;
                }
            });
        },
        getUnitDocTreeList() {
            api.getUnitDocTreeList({}).then((res) => {
                if (res) {
                    this.treeData = res.bus_json;
                    // let formatData = this.treeData && this.treeData[0];
                    // this.defaultCheckKeys = [formatData.tree_id];
                    // this.defaultExpandedKeys = [formatData.tree_id];
                    // this.tree_id = this.defaultCheckKeys[0];
                    // this.$nextTick(() => {
                    //     this.$refs.myTree.handleCheckBoxClick(formatData);
                    // });
                }
            });
        },
        handleTreeNodeClick(treeItem) {
            const index = this.addForm.deviceTags.indexOf(treeItem.tree_name);
            if (index == -1) {
                this.addForm.deviceTags.push(treeItem.tree_name);
                this.addForm.deviceIds.push(treeItem.tree_id);
            } else {
                this.addForm.deviceTags.splice(index, 1);
                this.addForm.deviceIds.splice(index, 1);
            }
        },
        getLeader() {
            api.getLeader().then((res) => {
                if (res.error_code == 0) {
                    this.leaders = res.bus_json;
                }
            });
        },
        changeLeader(row) {
            this.workers = [];
            this.addForm.worker_ids = '';
            this.leaders.forEach((item) => {
                if (item.leader_user_id == row) {
                    this.workers = item.userList;
                }
            });
        },
        //新增
        addOverhaulDialog() {
            this.overRegisterVisible = true;
            this.isLookLook = false;
            this.addForm.check_repair_id = '';
        },
        //修改
        changeOverhaulShow(row) {
            this.dialogTitle = '修改检修';
            this.isLookLook = false;
            this.overRegisterVisible = true;
            this.getCheckById(row.check_repair_id);
        },
        deleteItemShow(row) {
            this.$confirm('您确定删除这条数据吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then((_) => {
                api.deleteCheckById({
                    check_repair_id: row.check_repair_id,
                }).then((res) => {
                    if (res) {
                        this.$message({
                            type: 'success',
                            message: res.error_msg,
                        });
                        this.getCheckList();
                    }
                });
            });
        },
        //查看
        arrangeOverhaulShow(row) {
            this.dialogTitle = '查看检修';
            this.isLookLook = true;
            this.overRegisterVisible = true;
            this.getCheckById(row.check_repair_id);
        },
        getCheckById(check_repair_id) {
            api.getCheckById({
                check_repair_id,
            }).then((res) => {
                if (res) {
                    this.addForm.check_repair_id = res.bus_json.check_repair_id;
                    this.leaders.forEach((item) => {
                        if (item.leader_user_id == res.bus_json.leader_id) {
                            this.workers = item.userList;
                        }
                    });
                    this.addForm.plan_time_start = res.bus_json.plan_time_start;
                    this.addForm.plan_time_end = res.bus_json.plan_time_end;
                    this.addForm.leader_id = res.bus_json.leader_id;
                    this.addForm.worker_ids = res.bus_json.worker_ids.split(
                        ';'
                    );
                    this.addForm.out_worker_name = res.bus_json.out_worker_name;
                    this.addForm.is_power_cut = res.bus_json.is_power_cut;
                    this.addForm.remark = res.bus_json.remark;

                    let checkedKeys = [];
                    res.bus_json.repair_tree_list.forEach((item) => {
                        checkedKeys.push(item.tree_id);
                        this.$nextTick(() => {
                            this.$refs.myTree.handleCheckBoxClick(item);
                        });
                    });
                    this.$refs.myTree.$refs.tree.setCheckedKeys(checkedKeys);
                }
            });
        },
        /**
         * 列表条数改变回调
         */
        handleSizeChange(e) {
            this.pageNum = 1;
            this.pageSize = e;
        },
        /**
         * 企业列表页码改变回调
         */
        handleCurrentChange(e) {
            this.pageNum = e;
        },
        //新增保存
        changeCommit(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    api.saveCheck({
                        check_repair_id: this.addForm.check_repair_id,
                        tree_id_list: this.addForm.deviceIds,
                        plan_time_start: this.addForm.plan_time_start,
                        plan_time_end: this.addForm.plan_time_end,
                        leader_id: this.addForm.leader_id,
                        worker_ids: this.addForm.worker_ids.join(';'),
                        out_worker_name: this.addForm.out_worker_name,
                        is_power_cut: this.addForm.is_power_cut,
                        remark: this.addForm.remark,
                    }).then((res) => {
                        if (res) {
                            this.$message({
                                type: 'success',
                                message: res.error_msg,
                            });
                            this.overRegisterVisible = false;
                            this.getCheckList();
                        }
                    });
                }
            });
        },
        closeDialog() {
            this.$refs['addForm'].resetFields();
            this.$refs['addForm'].clearValidate();
            this.overRegisterVisible = false;
            this.addForm.deviceTags = [];
            this.addForm.deviceIds = [];
        },
    },
};
</script>
<style lang="scss">
.overhaul-register-con {
    width: 100%;
    height: 100%;
    padding: 0 20px;
    box-sizing: border-box;

    .overhaul-tab-wrap {
        flex: 1;
        display: flex;
        flex-flow: row wrap;
        border-spacing: 5px;
        width: 100%;
        margin: 0 0 5px 0;
        .el-tag {
            margin-left: 5px;
            /*color: #56fcff;*/
            /*background-color: #083472;*/
            /*border-color: #56fcff;*/
            display: table-cell !important;
            margin-bottom: 5px;
        }
        .el-tag .el-tag__close {
            /*color: #56fcff;*/
        }
    }
}
</style>
